<template lang="pug">
#visualizar-processamento-contrato
    BaseHeader(
        :titulo='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.titulo")',
        :exibeBotao='!foiConcluido',
        :btnTexto='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.concluirContrato")',
        icon='el-icon-check',
        :voltarPara='true',
        :desabilitaBotao='!botaoConcluirHabilitado',
        @btnHeaderClicado='concluirProcessamento'
    )

    .view-container.alinhar-conteudo.margen-bottom-pages
        div(v-if='mensagemValidacaoConcluir.length && !foiConcluido')
            el-alert(
                :title='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.avisos")',
                type='warning',
                show-icon,
                :closable='false'
            )
                ul
                    li(v-for='mensagem in mensagemValidacaoConcluir') {{ mensagem }}

        .blocoDadosVisualizarContratoOriginacao
            section
                BlocoDadosVisualizarContratoOriginacaoAlvorada(
                    :dados='dados',
                    v-if='isAlvorada',
                    @verificarConcluir='verificaConcluir'
                )
                SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR(
                    :dados='dados',
                    v-else-if='this.usuarioLogado.ambienteLogado === "AR"'
                )
                BlocoDadosVisualizarContratoOriginacao(:dados='dados', v-else)

        section
            Resumo(:resumo='resumo')

        ModalAnaliseElegibilidadePY(
            v-if='this.usuarioLogado.ambienteLogado === "PY"',
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosDetalheAnaliseElegibilidadePY',
            :dadosCalculoRaioPY='dadosCalculoRaioPY',
            :raiosPermitidosPorEstado='raiosPermitidosPorEstado',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        ModalAnaliseElegibilidadeResumoAr(
            v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        ModalAnaliseElegibilidade(
            v-else,
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            :raiosPermitidosPorEstado='raiosPermitidosPorEstado',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        section
            TabelaCarsInseridosNoContratoPY(
                v-if='this.usuarioLogado.ambienteLogado === "PY"',
                ref='tabelaTerritorioPY',
                :btnRecarregar='true',
                :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                :removendo='removendoTerritoriosCertificados',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :carregando='loadingTabelaCarsInseridosNoContrato',
                :paginacao='paginacao',
                :statusSubEmpresaCodigo='statusSubEmpresaCodigo',
                @removerTerritorioLote='removerTerritorioLote',
                @territorioRemovido='atualizarDados',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @realizarElegibilidade='realizarElegibilidade',
                @visualizarAnaliseElegibilidadePY='visualizarAnaliseElegibilidadePY',
                @atualizarTabela='atualizarListagemTerritorios'
            )
            TabelaCarsInseridosNoContratoAR(
                v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
                ref='tabelaTerritorioAR',
                :btnRecarregar='true',
                :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                :removendo='removendoTerritoriosCertificados',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :carregando='loadingTabelaCarsInseridosNoContrato',
                :paginacao='paginacao',
                :statusSubEmpresaCodigo='statusSubEmpresaCodigo',
                :idSucursal='$route.params.idSucursal || $route.query.idSucursal || 0',
                @removerTerritorioLote='removerTerritorioLote',
                @territorioRemovido='atualizarDados',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @realizarElegibilidade='realizarElegibilidade',
                @visualizarAnaliseElegibilidadeAr='visualizarAnaliseElegibilidadeAr',
                @atualizarTabela='atualizarListagemTerritorios'
            )
            TabelaCarsInseridosNoContrato(
                v-else,
                ref='tabelaTerritorio',
                :dados='dados',
                :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                :removendo='removendoTerritoriosCertificados',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :carregando='loadingTabelaCarsInseridosNoContrato',
                :paginacao='paginacao',
                @removerTerritorioLote='removerTerritorioLote',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @realizarElegibilidade='realizarElegibilidade',
                @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidade',
                @atualizarTabela='atualizarListagemTerritorios',
                :statusSubEmpresaCodigo='statusSubEmpresaCodigo'
            )
        footer.area-footer
            .botao-certificacao__remover
                el-button(
                    v-if='removendoTerritoriosCertificados',
                    @click.native='removendoTerritoriosCertificados = false'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.cancelar') }}

                el-button(
                    v-if='!removendoTerritoriosCertificados',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoTerritoriosCertificados = true',
                    :disabled='this.territoriosSelecionados.length === 0'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerTerritorio'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.confirmar') }}

            .botao-territorio__enviar-para-analise

    ModalDetalheAnalise(ref='refModalDetalheAnalise')
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoDadosVisualizarContratoOriginacao from '@/components/contratosOriginacao/SubEmpresaBlocoDadosVisualizarContratoOriginacao.vue';
import SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR from '@/components/contratosOriginacao/SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR.vue';
import BlocoDadosVisualizarContratoOriginacaoAlvorada from '@/components/contratosOriginacao/SubEmpresaBlocoDadosContratoOriginacaoAlvorada.vue';
import Resumo from '@/components/contratosOriginacao/SubEmpresaBlocoResumoContratoOriginacao.vue';
import TabelaCarsInseridosNoContrato from '@/components/contratosOriginacao/TabelaCarsInseridosNoContrato.vue';
import TabelaCarsInseridosNoContratoPY from '@/components/contratosOriginacao/TabelaCarsInseridosNoContratoPY.vue';
import TabelaCarsInseridosNoContratoAR from '@/components/contratosOriginacao/TabelaCarsInseridosNoContratoAR.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import MunicipioService from '@/services/MunicipioService';
import ModalAnaliseElegibilidade from '@/components/contratosOriginacao/ModalAnaliseElegibilidade.vue';
import ModalAnaliseElegibilidadePY from '@/components/contratosOriginacao/ModalAnaliseElegibilidadePY.vue';
import ModalAnaliseElegibilidadeResumoAr from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumoAr.vue';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mascaraRenspa } from '@/utils/masks/renspa.js';
import { mapGetters } from 'vuex';
import RaioPermitidoPorEstadoRastreabilidadeService from '@/services/RaioPermitidoPorEstadoRastreabilidadeService';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import LocalidadeService from '@/services/LocalidadeService';

export default {
    name: 'VisualizarProcessamentoContrato',
    components: {
        ModalDetalheAnalise,
        BaseHeader,
        BlocoDadosVisualizarContratoOriginacao,
        BlocoDadosVisualizarContratoOriginacaoAlvorada,
        SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR,
        Resumo,
        TabelaCarsInseridosNoContrato,
        TabelaCarsInseridosNoContratoPY,
        TabelaCarsInseridosNoContratoAR,
        ModalAnaliseElegibilidade,
        ModalAnaliseElegibilidadePY,
        ModalAnaliseElegibilidadeResumoAr
    },

    data() {
        return {
            numeroContrato: this.$route.params.numeroContrato,
            dados: {},
            resumo: {},
            botaoConcluirHabilitado: false,
            foiConcluido: false,
            ambientes: AmbientesEmpresas,
            mensagemValidacaoConcluir: [],
            habilitarBotaoConcluir: false,
            dataTerritoriosNaoEnviados: [],
            removendoTerritoriosCertificados: false,
            territoriosSelecionados: [],
            volumeDisponivelContrato: 0,
            loadingTabelaCarsInseridosNoContrato: false,
            raiosPermitidosPorEstado: [],
            paginacao: {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            },
            statusConcluidos: ['CONCLUIDO', 'AJUSTADO_PELA_REVENDA'],
            ativarModalAnaliseElegibilidade: false,
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                safraNome: '',
                dadosDiagnostico: {
                    territorioNome: '',
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            loadingResumo: {
                loadingRaio: false,
                loadingSaldo: false,
                analiseElegibilidade: false
            },
            statusSubEmpresaCodigo: '',
            dadosDetalheAnaliseElegibilidadePY: {},
            dadosCalculoRaioPY: {}
        };
    },

    mounted() {
        this.buscarRaiosPermitidosPorEstado();
        this.buscarInformacoesContrato();
        this.buscarTerritorios(0);
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada'])
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        async buscarInformacoesContrato() {
            try {
                let data = null;
                if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.PARAGUAY
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.buscarVisualizarProcessamentoSubEmpresaPY(
                            { numeroContrato: this.numeroContrato }
                        )
                    ).data;

                    const {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataContrato,
                        localidadeNivelUmNome,
                        localidadeNivelUmSigla,
                        municipioNome,
                        nomeCliente,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        volumeInseridoTotal,
                        saldo,
                        territoriosInseridos,
                        territoriosConformes,
                        territorioComAlertas,
                        territoriosInConformes,
                        statusSubEmpresaCodigo,
                        codigoExterno,
                        subTradingNome
                    } = data;

                    this.dados = {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataContrato,
                        localidadeNivelUmNome,
                        localidadeNivelUmSigla,
                        nomeCliente,
                        municipioNome,
                        codigoExterno,
                        saldoRestante: saldo,
                        volumeAdicionado: volumeInseridoTotal,
                        subTradingNome
                    };

                    this.resumo = {
                        volumeContratado,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        saldo,
                        territoriosInseridos,
                        territoriosConformes,
                        territoriosInConformes,
                        territorioComAlertas
                    };

                    this.foiConcluido = this.statusConcluidos.includes(statusSubEmpresaCodigo);
                    this.statusSubEmpresaCodigo = statusSubEmpresaCodigo;
                } else if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.ARGENTINA
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.buscarVisualizarProcessamentoSubEmpresaAR(
                            { numeroContrato: this.numeroContrato }
                        )
                    ).data;

                    const {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataCadastro,
                        localidadeNivelUmNome,
                        localidadeNivelUmSigla,
                        municipioNome,
                        nomeCliente,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        volumeInseridoTotal,
                        saldoRestante,
                        territoriosInseridos,
                        territoriosConformes,
                        territorioComAlertas,
                        territoriosInConformes,
                        statusSubEmpresaCodigo,
                        codigoExterno,
                        vendedor,
                        cuitVendedor,
                        anoColheitaAfip,
                        dataContrato,
                        plantaEntregaBungeNome,
                        dataPrevistaEntrega,
                        estruturaComercial,
                        condicaoCliente,
                        condicaoFrete,
                        localidadeNivelDoisSigla,
                        localidadeNivelDoisNome,
                        localidadeNivelDoisId,
                        localidadeNivelTresSigla,
                        localidadeNivelQuatroNome,
                        localidadeNivelTresId
                    } = data;

                    this.dados = {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataCadastro,
                        localidadeNivelUmNome,
                        localidadeNivelUmSigla,
                        nomeCliente,
                        municipioNome,
                        codigoExterno,
                        saldoRestante,
                        volumeInseridoTotal,
                        vendedor,
                        cuitVendedor,
                        anoColheitaAfip,
                        dataContrato,
                        dataPrevistaEntrega,
                        estruturaComercial,
                        plantaEntregaBungeNome,
                        condicaoCliente,
                        condicaoFrete,
                        localidadeNivelDoisSigla,
                        localidadeNivelDoisNome,
                        localidadeNivelDoisId,
                        localidadeNivelTresSigla,
                        localidadeNivelQuatroNome,
                        localidadeNivelTresId
                    };

                    this.resumo = {
                        volumeContratado,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        saldoRestante,
                        territoriosInseridos,
                        territoriosConformes,
                        territoriosInConformes,
                        territorioComAlertas
                    };

                    this.foiConcluido = this.statusConcluidos.includes(statusSubEmpresaCodigo);
                    this.statusSubEmpresaCodigo = statusSubEmpresaCodigo;
                } else {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.buscarVisualizarProcessamentoSubEmpresa(
                            { numeroContrato: this.numeroContrato }
                        )
                    ).data;

                    const {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataContrato,
                        estadoNome,
                        estadoSigla,
                        municipioNome,
                        nomeCliente,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        volumeInseridoTotal,
                        saldo,
                        territoriosInseridos,
                        territoriosConformes,
                        territorioComAlertas,
                        territoriosInConformes,
                        statusSubEmpresaCodigo,
                        codigoExterno
                    } = data;

                    this.dados = {
                        numeroContrato,
                        materialNome,
                        safraNome,
                        volumeContratado,
                        dataContrato,
                        estadoNome,
                        estadoSigla,
                        nomeCliente,
                        municipioNome,
                        codigoExterno,
                        saldoRestante: saldo,
                        volumeAdicionado: volumeInseridoTotal
                    };

                    this.resumo = {
                        volumeContratado,
                        volumeInseridoSemRestricao,
                        volumeComRestricoes,
                        saldo,
                        territoriosInseridos,
                        territoriosConformes,
                        territoriosInConformes,
                        territorioComAlertas
                    };

                    this.foiConcluido = this.statusConcluidos.includes(statusSubEmpresaCodigo);
                    this.statusSubEmpresaCodigo = statusSubEmpresaCodigo;
                }

                this.verificaConcluir();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.buscarInfoContrato'
                    )
                });
            }
        },

        async concluirProcessamento() {
            if (
                this.usuarioLogado.ambienteLogado === AmbientesEmpresas.PARAGUAY
            ) {
                this.concluirProcessamentoPY();
            } else if (
                this.usuarioLogado.ambienteLogado ===
                AmbientesEmpresas.ARGENTINA
            ) {
                this.concluirProcessamentoAR();
            } else {
                this.concluirProcessamentoBR();
            }
        },

        async concluirProcessamentoBR() {
            try {
                const resultado =
                    await ContratoOriginacaoServiceSubEmpresa.concluirProcessamentoContratoSubempresa(
                        { contrato: this.numeroContrato }
                    );

                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });

                this.$notify.success({
                    message: resultado.data
                });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async concluirProcessamentoPY() {
            try {
                const resultado =
                    await ContratoOriginacaoServiceSubEmpresa.concluirProcessamentoContratoSubempresaPY(
                        { contrato: this.numeroContrato }
                    );

                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });

                this.$notify.success({
                    message: resultado.data
                });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async concluirProcessamentoAR() {
            try {
                const resultado =
                    await ContratoOriginacaoServiceSubEmpresa.concluirProcessamentoContratoSubempresaAR(
                        { contrato: this.numeroContrato }
                    );

                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });

                this.$notify.success({
                    message: resultado.data
                });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async conectarCanalWebsocket() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.territorioInelegivel'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/contrato-originacao/subempresa/analise-concluida`,
                    response => {
                        this.buscarInformacoesContrato();
                        this.atualizarListagemTerritorios();
                        disconnect();
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.naoPossivelRealizarAnalise'
                    )
                });
                disconnect();
            }
        },

        async verificaConcluir() {
            this.mensagemValidacaoConcluir = [];
            if (
                this.usuarioLogado.ambienteLogado === AmbientesEmpresas.PARAGUAY
            ) {
                try {
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.verificaConcluirPY(
                            this.$route.params.numeroContrato
                        );

                    this.botaoConcluirHabilitado = data.podeConcluir;

                    this.mensagemValidacaoConcluir = data.avisos;

                    if (this.foiConcluido) {
                        this.botaoConcluirHabilitado = false;
                    } else {
                        this.conectarCanalWebsocket();
                    }
                } catch (error) {
                    this.mensagemValidacaoConcluir = [];

                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.contratoConcluido'
                        )
                    });
                }
            } else if (
                this.usuarioLogado.ambienteLogado ===
                AmbientesEmpresas.ARGENTINA
            ) {
                try {
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.verificaConcluirAR(
                            this.$route.params.numeroContrato
                        );

                    this.botaoConcluirHabilitado = data.podeConcluir;

                    this.mensagemValidacaoConcluir = data.avisos;

                    if (this.foiConcluido) {
                        this.botaoConcluirHabilitado = false;
                    } else {
                        this.conectarCanalWebsocket();
                    }
                } catch (error) {
                    this.mensagemValidacaoConcluir = [];

                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.contratoConcluido'
                        )
                    });
                }
            } else {
                try {
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.verificaConcluir(
                            this.$route.params.numeroContrato
                        );

                    this.botaoConcluirHabilitado = data.podeConcluir;

                    this.mensagemValidacaoConcluir = data.avisos;

                    if (this.foiConcluido) {
                        this.botaoConcluirHabilitado = false;
                    } else {
                        this.conectarCanalWebsocket();
                    }
                } catch (error) {
                    this.mensagemValidacaoConcluir = [];

                    if (error?.response?.data?.message) {
                        this.mensagemValidacaoConcluir.push(
                            error.response.data.message
                        );
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.contratoConcluido'
                            )
                        });
                    }
                }
            }
        },
        atualizarDados() {
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            setTimeout(() => {
                this.buscarTerritorios(0);
            }, 1000);
        },
        atualizarListagemTerritorios() {
            this.buscarTerritorios(0);
        },
        mudarPagina(novaPagina) {
            this.buscarTerritorios(novaPagina);
        },
        ordenarTabela(column) {
            /* if (column.prop === 'subEmpresaNome') {
                this.params.sort = 'empresaNome';
            } else {
                this.params.sort = column.prop;
            }

            if (column.order === 'ascending') {
                this.params.por = 'asc';
            } else if (column.order === 'descending') {
                this.params.por = 'desc';
            }
            this.buscarContratosEmpresa(); */
        },
        realizarElegibilidade(territorioAnalise) {
            this.territoriosSelecionados = territorioAnalise;
        },
        visualizarAnaliseElegibilidade(row) {
            if (
                this.loadingResumo.loadingRaio ||
                this.loadingResumo.loadingSaldo
            ) {
                this.$notify.warning({
                    message: 'Modal carregando...'
                });
                return;
            }
            this.dadosAnaliseElegibilidade.safraNome = this.dados.safraNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.codigoCar =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.cultura.codigo =
                this.dados.materialNome;
            this.dadosAnaliseElegibilidade.elegibilidade =
                row.codigoStatusElegibilidade;

            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoRepresentante =
                row.resumoDiagnosticoRepresentantes;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoCar =
                row.resumoDiagnosticoTerritorio;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.territorioNome =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.nivelAlertaRastreabilidade =
                row.nivelAlertaRastreabilidade;
            this.calcularRaio(row);
            this.buscarSaldo(row);
            this.ativarModalAnaliseElegibilidade = true;
        },
        async visualizarAnaliseElegibilidadePY(row) {
            if (
                this.loadingResumo.loadingRaio ||
                this.loadingResumo.loadingSaldo
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.modalCarregando'
                    )
                });
                return;
            }

            this.dadosDetalheAnaliseElegibilidadePY = row;

            await this.calcularRaioPY(row);
            this.ativarModalAnaliseElegibilidade = true;
        },
        async visualizarAnaliseElegibilidadeAr(row) {
            try {
                const numeroContrato = this.$route.params.numeroContrato;
                const idTerritorio = row.idTerritorio;
                const idSucursal = this.$route.params.idSucursal || this.$route.query.idSucursal || 0;

                // Usar endpoint consolidado em vez dos endpoints antigos
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr({
                    idRepresentante: 0,
                    idTerritorio: idTerritorio,
                    numeroContrato: numeroContrato,
                    isSucursal: false,
                    idDadosContratoOriginacao: row.id,
                    idSucursal
                });

                // Mapear dados para estrutura unificada
                this.dadosAnaliseElegibilidade.dadosDiagnostico = data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = data.raioTerritorio;
                this.dadosAnaliseElegibilidade.elegibilidade = data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.saldoTerritorial = data.diagnosticoSaldoTerritorial;
                this.dadosAnaliseElegibilidade.territorioOutput = data.territorioOutput;
                this.dadosAnaliseElegibilidade.certificacao = data.certificacao;
                
                this.ativarModalAnaliseElegibilidade = true;
            } catch (e) {
                 if (
                    e.response?.data?.message ===
                    'rendimento.provinciaEDepartamentoNaoEncontrado'
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroRendimento'
                        )
                    });
                    return;
                }

                this.$notify.error({
                    message: e.response?.data?.message
                });
            }
        },
        async calcularRaio(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                numeroContrato: this.numeroContrato
            };

            try {
                const response =
                    await MunicipioService.ValidarMunicipioRaioAceiteCar(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.numeroCarNaoEncontratoApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        async calcularRaioPY(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroContrato: this.numeroContrato,
                geometriaTerritorio: null
            };

            try {
                const response = await LocalidadeService.validarRaioLocalidade(
                    dados,
                    true
                );
                this.dadosCalculoRaioPY = response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.numeroCarVegaApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        async buscarSaldo(linhaDados) {
            this.loadingResumo.loadingSaldo = true;
            const dados = {
                codigoCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                idTerritorio: linhaDados.idTerritorio,
                nomeMaterial: this.dados.materialNome,
                anoSafra: this.dados.safraNome,
                numeroContrato: this.numeroContrato
            };

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.buscarSaldo(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
            this.loadingResumo.loadingSaldo = false;
        },
        async buscarTerritorios(pagina) {
            this.loadingTabelaCarsInseridosNoContrato = true;
            this.paginacao.pagina = pagina;
            let data = null;
            if (
                this.usuarioLogado.ambienteLogado === AmbientesEmpresas.PARAGUAY
            ) {
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContratoPY(
                        {
                            contrato: this.$route.params.numeroContrato,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;
            } else if (
                this.usuarioLogado.ambienteLogado ===
                AmbientesEmpresas.ARGENTINA
            ) {
                // novo endpoint
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContratoAR(
                        {
                            contrato: this.$route.params.numeroContrato,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;

                const dataRenspaFormatado = data.itens.map(item => ({
                    ...item,
                    cuit: this.alterarMascara(
                        item.territorioRepresentantes[0].cpfCnpj
                    ),
                    renspaTerritorio: mascaraRenspa(item.renspaTerritorio)
                }));

                this.dataTerritoriosNaoEnviados = dataRenspaFormatado;
            } else {
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContrato(
                        {
                            contrato: this.$route.params.numeroContrato,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;
            }

            if (this.usuarioLogado.ambienteLogado !== 'AR') {
                this.dataTerritoriosNaoEnviados = data.itens;
            }

            this.paginacao = { ...data.paginacao };
            this.paginacao.pagina += 1;
            this.loadingTabelaCarsInseridosNoContrato = false;
        },
        removerTerritorioLote(territorioRemover) {
            this.territoriosSelecionados = territorioRemover;
        },
        alterarMascara(cpf) {
            const somenteNumeros = cpf.replace(/\D/g, '');
            const novaMascara = somenteNumeros.replace(
                /^(\d{2})(\d{8})(\d)$/,
                '$1-$2-$3'
            );

            return novaMascara;
        },
        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.naoHaTerritoriosRemocao'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.territoriosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.removerTerritorio'
                          )
                        : this.$t(
                              'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.removerTerritorios'
                          ),
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                    ),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                try {
                    if (this.usuarioLogado.ambienteLogado === 'PY') {
                        await this.$nextTick(() => {
                            this.$refs.tabelaTerritorioPY.removerTerritoriosEmLote(
                                this.territoriosSelecionados
                            );
                        });
                    } else if (this.usuarioLogado.ambienteLogado === 'AR') {
                        await this.$nextTick(() => {
                            this.$refs.tabelaTerritorioAR.removerTerritoriosEmLote(
                                this.territoriosSelecionados
                            );
                        });
                    } else {
                        this.$nextTick(() => {
                            this.$refs.tabelaTerritorio.removerTerritoriosEmLote(
                                this.territoriosSelecionados
                            );
                        });
                    }
                    this.removendoTerritoriosCertificados = false;
                    this.atualizarDados();
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.erroRequisicao'
                        )
                    });
                }
                // this.$notify.success(
                //    this.territoriosSelecionados.length === 1
                //        ? 'Território removido.'
                //        : 'Territórios removidos.'
                // );
            }
        },
        async buscarRaiosPermitidosPorEstado() {
            const { data } =
                await RaioPermitidoPorEstadoRastreabilidadeService.findAll();
            this.raiosPermitidosPorEstado = data;
        }
    }
};
</script>

<style lang="scss">
#visualizar-processamento-contrato {
    .alinhar-conteudo {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 16px;
    }

    .el-alert__title {
        color: #737373;
    }

    .el-alert__description {
        color: #737373;
    }

    .area-footer {
        display: flex;
        justify-content: space-between;
    }
}
</style>
